export default {
  hot_news: "СРОЧНОЕ".toUpperCase(),
};
